<template>
  <div class="d-flex align-items-center min-vh-100 login-container">
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="9" lg="6" class="login">
          <b-card-group>
            <b-card class="p-4 shadow-lg">
              <b-card-body class="login-box">
                <b-form>
                  <div class="text-center img-logo-cover">
                    <!-- <img src="/logo.png" alt /> -->
                    <div
                      class="imgLogo"
                      v-bind:style="{
                        'background-image': 'url(' + imgLogo + ')',
                      }"
                    ></div>
                    <hr class="my-4" />
                  </div>
                  <InputText
                    class="my-3 login-input"
                    v-model="form.username"
                    textFloat="Email"
                    placeholder="อีเมล"
                    type="email"
                    name="email"
                    isRequired
                    :isValidate="$v.form.username.$error"
                    :v="$v.form.username"
                    @onKeyup="submitFormOnInput"
                  />
                  <InputText
                    class="my-3 login-input"
                    v-model="form.password"
                    textFloat="Password"
                    placeholder="รหัสผ่าน"
                    type="password"
                    name="password"
                    isRequired
                    :isValidate="$v.form.password.$error"
                    :v="$v.form.password"
                    @onKeyup="submitFormOnInput"
                    isShowPassword
                  />
                  <b-row v-if="error != ''" class="m-2 text-center">
                    <span class="text-danger w-100">
                      {{ error }}
                      <br />
                      {{ " " }}
                    </span>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button
                        type="button"
                        class="px-4 login-btn"
                        @click="checkForm"
                        :disabled="isDisable"
                        >เข้าสู่ระบบ
                        <b-spinner
                          class="align-middle w-1rem"
                          v-if="isLogin"
                        ></b-spinner
                      ></b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </b-container>

    <ModalComingSoon ref="modalComingSoon" />
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import ModalComingSoon from "@/components/modal/alert/ModalComingSoon";
import imgLogo from "@/assets/images/logo.svg";

export default {
  name: "Login",
  components: {
    InputText,
    ModalComingSoon,
  },
  data() {
    return {
      imgLogo: imgLogo,
      error: "",
      form: {
        username: "",
        password: "",
      },
      isLoading: false,
      isDisable: false,
      isLogin: false,
      passwordType: "",
    };
  },
  validations() {
    return {
      form: {
        username: { required, email },
        password: { required },
      },
    };
  },
  mounted: async function() {},
  created() {},
  methods: {
    checkForm: async function() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      this.isLoading = true;
      this.isDisable = true;
      this.isLogin = true;
      this.error = "";
      this.axios.post(`${this.$baseUrl}/user/login`, this.form).then((data) => {
        if (data.result == 1) {
          this.$cookies.set("admin-token", data.detail, 60 * 60 * 24 * 30);
          var myHeaders = new Headers();
          myHeaders.append("API-KEY", this.$chatAPIKey);
          myHeaders.append("Authorization", "Bearer " + data.detail);
          myHeaders.append("Content-Type", "application/json");

          var raw = JSON.stringify({
            email: this.form.username,
            password: this.form.password,
            token: data.detail,
          });

          var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
          };

          fetch(this.$chatBaseUrl + "/user/update-token", requestOptions)
            .then((response) => response.json())
            .then((result) => {
              if (result.result) {
                // this.axios.get(`${this.$baseUrl}/user`).then((res) => {
                  window.location.href = `/chat-analysis?brandID=${result.detail.brandId}`;
                  this.isLoading = false;
                  this.isDisable = false;
                  this.isLogin = false;
                // });
              }
            })
            .catch((error) => console.log("error", error));
        } else {
          this.isLoading = false;
          this.isLogin = false;
          this.isDisable = false;
          this.error = 'อีเมลหรือรหัสผ่านไม่ถูกต้อง'; //data.message;
        }
      });
    },
    submitFormOnInput: function(e) {
      if (e.keyCode === 13) {
        this.checkForm();
      }
    },
    handleShowHidePassword() {
      if (this.passwordType == "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
  },
};
</script>

<style scoped>
.w-1rem {
  width: 1rem;
  height: 1rem;
}

.button-eye {
  position: absolute;
  right: 10px;
  top: 0.8rem;
  z-index: 6;
}
</style>
